export const feedbacksStats = [
    { name: "Pergunta", value: "prompt", filter: false, completeValue: "completePrompt"},
    { name: "Nota 1", value: "one", filter: false, image: true, imageName: require('@/assets/images/emojis/emoji-1.svg') },
    { name: "Nota 2", value: "two", filter: false , image: true, imageName: require('@/assets/images/emojis/emoji-2.svg')},
    { name: "Nota 3", value: "three", filter: false, image: true, imageName: require('@/assets/images/emojis/emoji-3.svg') },
    { name: "Nota 4", value: "four", filter: false, image: true, imageName: require('@/assets/images/emojis/emoji-4.svg') },
    { name: "Nota 5", value: "five", filter: false, image: true, imageName: require('@/assets/images/emojis/emoji-5.svg') },
    { name: "NPS", value: "netPromoterScore", filter: false },

  ];